import {ListItemIcon, Menu, MenuItem} from "@material-ui/core";
import {ControlPointDuplicate} from "@material-ui/icons";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import React, {useMemo} from "react";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(() => ({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    },
}));
const ContextMenu = (props) => {
    const classes = useStyles();
    const {contextMenu, onClose, duplicateItem, removeItem, addItem} = props;

    const isOpen = useMemo(() => {
        return contextMenu.mouseY !== null && contextMenu.mouseX !== null
    }, [contextMenu.mouseY, contextMenu.mouseX])

    return (
        <Menu
            classes={{list: classes.contextPaper}}
            open={contextMenu.mouseY !== null}
            anchorReference={"anchorPosition"}
            anchorPosition={isOpen ? {top: contextMenu.mouseY, left: contextMenu.mouseX} : undefined}
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addItem && addItem(0);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <ControlPointDuplicate fontSize="small"/>
                </ListItemIcon>
                Add Before
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addItem && addItem(1);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <ControlPointDuplicate fontSize="small"/>
                </ListItemIcon>
                Add After
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    duplicateItem && duplicateItem();
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <ControlPointDuplicate fontSize="small"/>
                </ListItemIcon>
                Duplicate
            </MenuItem>

            {removeItem && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        removeItem();
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <HighlightOffIcon fontSize="small"/>
                    </ListItemIcon>
                    Remove
                </MenuItem>
            )}

        </Menu>
    )
}

export default ContextMenu;